import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DasRPSvgColorMedium = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10.5 14L20 20L15 23" stroke="#A1A1A1" strokeWidth="2" />
      <path d="M21.5 14L12 20L17 23" stroke="#A1A1A1" strokeWidth="2" />
      <path
        d="M24 15H8V5H24V15ZM17 13H22V11H17V13ZM10 13H15V11H10V13ZM17 9H22V7H17V9ZM10 9H15V7H10V9Z"
        fill="#E6A600"
      />
      <circle cx="22.5" cy="25.5" r="1.5" fill="#A1A1A1" />
      <circle cx="9.5" cy="25.5" r="1.5" fill="#A1A1A1" />
      <path
        d="M24 23.5029C23.5819 23.1884 23.0635 23 22.5 23C21.1193 23 20 24.1193 20 25.5C20 25.6712 20.017 25.8385 20.0498 26H11.9502C11.983 25.8385 12 25.6712 12 25.5C12 24.1193 10.8807 23 9.5 23C8.93653 23 8.41809 23.1884 8 23.5029V22H22V21H24V23.5029Z"
        fill="#E6A600"
      />
    </SvgIcon>
  );
};

export default DasRPSvgColorMedium;
